import PropTypes from 'prop-types';

import { useMessages } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import BackButton from '#client/components/BackButton';
import OneColumnLayout from '#client/layouts/OneColumnLayout';

import QuestionsForm from './components/QuestionsForm';
import { QuestionsProvider } from './hooks/useQuestions';

const MESSAGE_KEY = 'shopping.page.questions';
const MESSAGE_IDS = {
  title: `${MESSAGE_KEY}.title`,
  subtitle: `${MESSAGE_KEY}.subtitle`
};

const QuestionsPage = (props) => {
  const { formationCountyStates } = props;
  const { subtitle, title } = useMessages(MESSAGE_IDS);

  return (
    <QuestionsProvider>
      <OneColumnLayout>
        <BackButton />
        <Stack component="header" gap={1}>
          <Heading component="h1" size="lg" weight="medium" wrap="wrap">
            {title}
          </Heading>
          <Text size="md">{subtitle}</Text>
        </Stack>
        <QuestionsForm formationCountyStates={formationCountyStates} />
      </OneColumnLayout>
    </QuestionsProvider>
  );
};

QuestionsPage.propTypes = {
  formationCountyStates: PropTypes.instanceOf(Set)
};

export default QuestionsPage;
